import {
  type APIResponse,
  type MatterRole,
  type MatterTeam,
  type MatterTeammate,
} from "@/lib/types";
import { authenticatedFastApiAxiosInstance } from "../../http";
import { baseFastApiMatterRoute } from "./matter";

export const retrieveMatterTeammatesV1 = (data: Pick<MatterTeam, "id">) => {
  return authenticatedFastApiAxiosInstance
    .get<
      APIResponse<MatterTeammate[]>
    >(`${baseFastApiMatterRoute}/teams/${data.id}/teammates`)
    .then((res) => res.data);
};

export const createMatterTeammateV1 = (data: {
  roleId: MatterRole["id"];
  teamId: MatterTeam["id"];
  user: { userId: string };
}) => {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<MatterTeam>
    >(`${baseFastApiMatterRoute}/teams/teammates`, data)
    .then((res) => res.data);
};

export const updateMatterTeammateV1 = (
  data: Pick<MatterTeammate, "id" | "dateModified"> & {
    roleId: MatterRole["id"];
    teamId: MatterTeam["id"];
    userId?: string;
  },
) => {
  return authenticatedFastApiAxiosInstance
    .patch<
      APIResponse<MatterTeammate>
    >(`${baseFastApiMatterRoute}/teams/teammates`, data)
    .then((res) => res.data);
};

export const deleteMatterTeammateV1 = (data: {
  id: MatterTeammate["id"];
  teamId: MatterTeam["id"];
}) => {
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MatterTeammate>
    >(`${baseFastApiMatterRoute}/teams/${data.teamId}/teammates/${data.id}`)
    .then((res) => res.data);
};
